module.exports = __webpack_public_path__ + "static/img/arrow-right-dark.dd584fc9.svg";